const FETCH_BLOCKED_USERS = 'blockedUserList/FETCH_BLOCKED_USERS';

const RESET_BLOCKED_USERS = 'blockedUserList/RESET_BLOCKED_USERS';

export default {
  FETCH_BLOCKED_USERS,
  RESET_BLOCKED_USERS,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/blockedUserList/types.js